// Mock data for Ewen Realtors redesign - uses exact photos from ewenrealtors.com

const BASE = '';

export const heroSlides = [
  { id: 1, image: `/slides/slide1.jpeg`, eyebrow: 'Defining Dreams Since 2013', title: 'Own a Piece of the Himalayas', subtitle: 'Freehold villas, plots and farmhouses in the heart of Uttarakhand.' },
  { id: 2, image: `/slides/slide2.jpg`, eyebrow: 'The Ewen Park \u2014 Ranikhet', title: 'Where Nature Lives', subtitle: 'A gated township wrapped in pine forests and snow\u2011capped views.' },
  { id: 3, image: `/slides/slide3.jpg`, eyebrow: 'RERA No. UKREA05230000398', title: 'Legacy Homes, Timeless Land', subtitle: 'Trusted by 500+ families across India and abroad.' },
  { id: 4, image: `/slides/slide4.png`, eyebrow: 'Freehold & RERA Approved', title: 'A Home That Registers On Your Name', subtitle: '100% clear title. Zero surprises. Total peace of mind.' },
  { id: 5, image: `/slides/slide5.jpg`, eyebrow: 'Uttarakhand\u2019s Finest', title: 'Where the Mountains Meet the Sky', subtitle: 'Ranikhet \u00b7 Almora' },
];

export const uspItems = [
  { title: 'Smart Living', image: `${BASE}/assets/23_04_25/Usp/smart%20lifestyle.jpg` },
  { title: 'Sustainability', image: `${BASE}/assets/23_04_25/Usp/sustainability.jpg` },
  { title: 'Peaceful', image: `${BASE}/assets/23_04_25/Usp/yoga-girl.jpg` },
  { title: 'Thriving Community', image: `${BASE}/assets/23_04_25/Usp/children%20playing.jpeg` },
  { title: 'Untouched Nature', image: `${BASE}/assets/23_04_25/Usp/nature%20-%20himalyan%20view.jpg` },
];

export const projects = [
  {
    id: 'ewen-park',
    name: 'The Ewen Park',
    location: 'Ranikhet, Uttarakhand',
    tag: 'Flagship',
    price: 'Starting \u20b924.5 L',
    image: `${BASE}/assets/23_04_25/hill%20stations/almora.jpg`,
    features: ['Freehold Land', 'Himalayan View', 'Gated Township'],
    tagline: 'A gated Himalayan township wrapped in pine and silence.',
    description: 'Set at 6,000 ft above sea level, The Ewen Park is our flagship freehold township. 86 acres of curated plots, villa builds and shared amenities \u2014 all with a full 180\u00b0 view of the Nanda Devi range.',
    gallery: [
      `${BASE}/assets/23_04_25/hill%20stations/almora.jpg`,
      `${BASE}/assets/23_04_25/nearby%20places/chaubatia%20garden.jpg`,
      `${BASE}/assets/23_04_25/Usp/nature%20-%20himalyan%20view.jpg`,
      `${BASE}/assets/23_04_25/Usp/smart%20lifestyle.jpg`,
      `${BASE}/assets/23_04_25/Usp/sustainability.jpg`,
      `${BASE}/assets/23_04_25/nearby%20places/rani%20jheel.jpg`,
    ],
    highlights: [
      { label: 'Township Size', value: '86 Acres' },
      { label: 'Altitude', value: '6,000 ft' },
      { label: 'Plot Sizes', value: '1000 \u2013 5000 sqft' },
      { label: 'Delivery', value: '2026 onwards' },
    ],
    floorPlans: [
      { name: 'Studio Villa \u2022 700 sqft', beds: 1, baths: 1, area: '700 sqft', price: '\u20b942 L' },
      { name: 'Deodar 2BHK \u2022 1250 sqft', beds: 2, baths: 2, area: '1250 sqft', price: '\u20b978 L' },
      { name: 'Pine 3BHK \u2022 1850 sqft', beds: 3, baths: 3, area: '1850 sqft', price: '\u20b91.24 Cr' },
      { name: 'Nanda Villa \u2022 2600 sqft', beds: 4, baths: 4, area: '2600 sqft', price: '\u20b91.85 Cr' },
    ],
    amenities: ['Clubhouse', 'Cafe & Library', 'Meditation Deck', 'Organic Farm', '24/7 Security', 'Power Backup', 'Water Harvesting', 'EV Charging'],
    map: 'Ranikhet, Almora district, Uttarakhand',
  },
  {
    id: 'pine-heights',
    name: 'Pine Heights',
    location: 'Almora, Uttarakhand',
    tag: 'New Launch',
    price: 'Starting \u20b918.9 L',
    image: `${BASE}/assets/23_04_25/hill%20stations/mukteshwar.jpg`,
    features: ['Villa Plots', 'Pine Forest', 'South Facing'],
    tagline: 'South\u2011facing plots in a dense pine forest.',
    description: 'Pine Heights is a boutique gated community of 42 south\u2011facing plots carved into a mature pine forest just outside Almora town.',
    gallery: [
      `${BASE}/assets/23_04_25/hill%20stations/mukteshwar.jpg`,
      `${BASE}/assets/23_04_25/hill%20stations/Bhowali_City.jpg`,
      `${BASE}/assets/23_04_25/Usp/yoga-girl.jpg`,
      `${BASE}/assets/23_04_25/Usp/children%20playing.jpeg`,
      `${BASE}/assets/23_04_25/nearby%20places/katarmal%20suntemple.jpg`,
      `${BASE}/assets/23_04_25/hill%20stations/Bhimtal.jpg`,
    ],
    highlights: [
      { label: 'Total Plots', value: '42' },
      { label: 'Altitude', value: '5,400 ft' },
      { label: 'Plot Sizes', value: '900 \u2013 2400 sqft' },
      { label: 'Delivery', value: '2025 onwards' },
    ],
    floorPlans: [
      { name: 'Cottage 1BHK \u2022 600 sqft', beds: 1, baths: 1, area: '600 sqft', price: '\u20b935 L' },
      { name: 'Pine 2BHK \u2022 1100 sqft', beds: 2, baths: 2, area: '1100 sqft', price: '\u20b968 L' },
      { name: 'Deluxe 3BHK \u2022 1650 sqft', beds: 3, baths: 3, area: '1650 sqft', price: '\u20b91.05 Cr' },
    ],
    amenities: ['Community Deck', 'Trail Access', 'Bonfire Court', 'Herb Garden', 'Security', 'Power Backup'],
    map: 'Almora, Uttarakhand',
  },
  {
    id: 'kausani-vista',
    name: 'Kausani Vista',
    location: 'Kausani, Uttarakhand',
    tag: 'Limited',
    price: 'Starting \u20b932.0 L',
    image: `${BASE}/assets/23_04_25/hill%20stations/kausani.jpg`,
    features: ['Farmhouse Land', '180\u00b0 Views', 'Clubhouse'],
    tagline: 'Farmhouse land with a 180\u00b0 view Gandhi called \u201cthe Switzerland of India.\u201d',
    description: 'Kausani Vista is a limited\u2011edition farmhouse project of just 18 estate plots, each with a sweeping 180\u00b0 view of the Trishul, Nanda Devi and Panchachuli peaks.',
    gallery: [
      `${BASE}/assets/23_04_25/hill%20stations/kausani.jpg`,
      `${BASE}/assets/23_04_25/hill%20stations/nainital.jpg`,
      `${BASE}/assets/23_04_25/nearby%20places/nanda_devi.jpg`,
      `${BASE}/assets/23_04_25/nearby%20places/Mankameshwar-Temple.webp`,
      `${BASE}/assets/23_04_25/Usp/sustainability.jpg`,
      `${BASE}/assets/23_04_25/Usp/nature%20-%20himalyan%20view.jpg`,
    ],
    highlights: [
      { label: 'Estate Plots', value: '18' },
      { label: 'Altitude', value: '6,200 ft' },
      { label: 'Plot Sizes', value: '2500 \u2013 7000 sqft' },
      { label: 'Delivery', value: '2026 onwards' },
    ],
    floorPlans: [
      { name: 'Orchard Home \u2022 1600 sqft', beds: 2, baths: 2, area: '1600 sqft', price: '\u20b91.15 Cr' },
      { name: 'Peak View Villa \u2022 2200 sqft', beds: 3, baths: 3, area: '2200 sqft', price: '\u20b91.62 Cr' },
      { name: 'Estate Farmhouse \u2022 3500 sqft', beds: 4, baths: 4, area: '3500 sqft', price: '\u20b92.45 Cr' },
    ],
    amenities: ['Private Orchard', 'Infinity Deck', 'Farm to Table Cafe', 'Yoga Pavilion', 'Concierge', 'Managed Rentals'],
    map: 'Kausani, Bageshwar district, Uttarakhand',
  },
];

export const paymentPlan = [
  { step: '01', title: 'Booking Amount', percent: '40%', note: '15 days window to finalize the decision.' },
  { step: '02', title: '1st Installment', percent: '15%', note: 'Payable within 1 month of booking.' },
  { step: '03', title: '2nd Installment', percent: '15%', note: 'Payable within 1 month.' },
  { step: '04', title: '3rd Installment', percent: '15%', note: 'Payable within 1 month.' },
  { step: '05', title: 'Final Payment', percent: '15%', note: 'Freehold land registered in your name.' },
];

export const nearbyAttractions = [
  { name: 'Chaubatia Garden', distance: '26 Km', image: `${BASE}/assets/23_04_25/nearby%20places/chaubatia%20garden.jpg` },
  { name: 'Rani Jheel', distance: '19.2 Km', image: `${BASE}/assets/23_04_25/nearby%20places/rani%20jheel.jpg` },
  { name: 'Golf Ground', distance: '12.5 Km', image: `${BASE}/assets/23_04_25/nearby%20places/Golf-Course.jpg` },
  { name: 'Haidakhan Temple', distance: '22 Km', image: `${BASE}/assets/23_04_25/nearby%20places/haidakhan-temple.jpg` },
  { name: 'Katarmal Sun Temple', distance: '14.3 Km', image: `${BASE}/assets/23_04_25/nearby%20places/katarmal%20suntemple.jpg` },
  { name: 'Mankameshwar Temple', distance: '18.4 Km', image: `${BASE}/assets/23_04_25/nearby%20places/Mankameshwar-Temple.webp` },
  { name: 'Kumaon Regimental Museum', distance: '18.8 Km', image: `${BASE}/assets/23_04_25/nearby%20places/Kumaon-Regimental-Centre-Museum.jpg` },
];

export const hillStations = [
  { name: 'Naukuchiatal', distance: '74 Km', image: `${BASE}/assets/23_04_25/hill%20stations/naukuchiatal.jpg` },
  { name: 'Almora', distance: '28.4 Km', image: `${BASE}/assets/23_04_25/hill%20stations/almora.jpg` },
  { name: 'Bhimtal', distance: '71 Km', image: `${BASE}/assets/23_04_25/hill%20stations/Bhimtal.jpg` },
  { name: 'Bhowali', distance: '59 Km', image: `${BASE}/assets/23_04_25/hill%20stations/Bhowali_City.jpg` },
  { name: 'Nainital', distance: '71 Km', image: `${BASE}/assets/23_04_25/hill%20stations/nainital.jpg` },
];

export const stats = [
  { value: '11+', label: 'Years of Trust' },
  { value: '500+', label: 'Happy Families' },
  { value: '3', label: 'Signature Townships' },
  { value: '100%', label: 'Freehold Land' },
];

export const testimonials = [
  { name: 'Ananya Sharma', city: 'Delhi', text: 'From site visit to registration \u2014 the team held our hand at every step. Our weekend home in Ranikhet is a dream come true.' },
  { name: 'Colonel R. Menon', city: 'Bengaluru', text: 'I have bought land in three states. Ewen Realtors set a new bar for transparency and professionalism.' },
  { name: 'Priya & Rohan Kapoor', city: 'Mumbai', text: 'The Himalayan view from our balcony still feels unreal. Grateful for such an honest developer.' },
];

export const blogPosts = [
  { slug: 'himalayan-view-property-in-ranikhet-uttarakhand', title: 'Why a Himalayan\u2011View Property is the Best Investment of 2025', excerpt: 'Uttarakhand real estate is booming. Here is what smart buyers are watching this year.', image: `${BASE}/assets/23_04_25/hill%20stations/almora.jpg`, date: 'Jul 12, 2025', read: '6 min', author: 'Rajesh Rawat', tag: 'Investment',
    body: [
      'Ten years ago, a plot in Ranikhet cost a fraction of a small flat in Delhi. Today, that same plot appreciates faster than most equity portfolios and, unlike equity, gives you weekends under a snow-capped sky.',
      'The reasons are simple. Uttarakhand\u2019s ceiling on external buyers keeps supply tight. Infrastructure \u2014 the Delhi-Dehradun expressway, the Kathgodam rail upgrade, the new Pantnagar airport \u2014 keeps demand climbing. And a new generation of remote workers wants a second address in the hills.',
      'What should you look for in 2025? Three things: freehold title with a clean chain, RERA registration, and a developer who has actually delivered projects before. Skip anything else.',
      'If you are still on the fence, come see us. Bring the family. We\u2019ll host you at the site for a night and let the mountains do the pitching.',
    ],
  },
  { slug: 'best-opportunity-to-buy-a-farmhouse-in-uttarakhand', title: 'Buying a Farmhouse in Uttarakhand: A Complete 2025 Guide', excerpt: 'Legal checks, RERA, freehold vs. leasehold \u2014 everything you should know before you sign.', image: `${BASE}/assets/23_04_25/hill%20stations/kausani.jpg`, date: 'Jun 30, 2025', read: '9 min', author: 'Anjali Bisht', tag: 'Guide',
    body: [
      'A farmhouse in Uttarakhand sounds romantic \u2014 and it can be. But the paperwork is where dreams either take flight or crash-land. This guide walks you through it.',
      'First, verify the land use. Only agricultural land can technically be called a farmhouse; anything else is a residential plot in disguise. Ask for the khasra number and pull the record online from the Bhulekh portal.',
      'Second, confirm the seller\u2019s chain of title \u2014 at least 30 years back. Any single break invalidates the sale. A local advocate can do this in a week.',
      'Third, insist on freehold. Leasehold in the hills usually means a 30 or 99 year lease from the government \u2014 fine for a bungalow, painful for a family estate.',
      'Fourth, only buy from a RERA-registered developer. UKREA registrations are public and searchable. Ours is UKREA05230000398.',
      'Finally, plan for construction rules. Uttarakhand caps hill construction at G+2 with 40% ground coverage. Do not believe anyone who tells you otherwise.',
    ],
  },
  { slug: 'best-places-to-buy-a-retirement-home-in-uttarakhand', title: 'The Best Places to Build Your Retirement Home in the Hills', excerpt: 'Weather, healthcare, connectivity \u2014 our shortlist of towns for a peaceful second innings.', image: `${BASE}/assets/23_04_25/hill%20stations/mukteshwar.jpg`, date: 'Jun 18, 2025', read: '7 min', author: 'Rajesh Rawat', tag: 'Lifestyle',
    body: [
      'Retirement in the mountains sounds idyllic \u2014 and it is, if you pick the right town. Three variables matter: weather, healthcare, and how quickly a road connects you back to a major city.',
      'Ranikhet wins on all three. Mild summers, gentle winters (unlike Mussoorie), a Base Hospital run by the Kumaon Regiment, and a four-hour drive to Kathgodam railway station.',
      'Almora is a close second \u2014 more cultural, slightly more crowded, and blessed with excellent private healthcare in the last three years.',
      'Mukteshwar is the third contender \u2014 quieter, cooler, and further from a hospital. Fine for the fit, tricky if you have chronic care needs.',
      'Whatever you pick, buy near a town, not inside it. You get the view and the quiet, and stay ten minutes from the pharmacy.',
    ],
  },
  { slug: 'buy-himalayan-view-property-near-delhi', title: 'Buy a Himalayan\u2011View Property Near Delhi', excerpt: 'Weekend drive from NCR to your own slice of the Himalayas.', image: `${BASE}/assets/23_04_25/hill%20stations/nainital.jpg`, date: 'Jun 04, 2025', read: '5 min', author: 'Anjali Bisht', tag: 'NCR Buyers',
    body: [
      'The Delhi-Dehradun expressway has quietly changed everything. What was a nine-hour drive is now under five. Kathgodam is six.',
      'That means a Friday-evening departure gets you a full weekend in the hills \u2014 and back home in time for Monday standup. This one shift has moved hundreds of NCR buyers off the fence.',
      'The sweet spot for weekenders is anywhere within 30 minutes of Kathgodam railway station \u2014 Bhimtal, Bhowali, Ranikhet foothills. Above that, you buy the view; below that, you buy the visits.',
    ],
  },
  { slug: 'build-your-spiritual-dream-home-in-ranikhet', title: 'Build Your Spiritual Dream Home in Ranikhet', excerpt: 'Where temples, forests and silence meet.', image: `${BASE}/assets/23_04_25/nearby%20places/haidakhan-temple.jpg`, date: 'May 21, 2025', read: '4 min', author: 'Rajesh Rawat', tag: 'Ranikhet',
    body: [
      'There is a reason so many saints, monks and seekers have settled in the Kumaon foothills. The silence here has a weight to it \u2014 something the concrete cities can never quite manufacture.',
      'Around Ranikhet, you have Kainchi Dham, Haidakhan Babaji Ashram, Katarmal Sun Temple, and half a dozen quiet pilgrimages. A home here is not just an address; it is proximity to whatever practice you keep.',
      'For our spiritual buyers we design homes with a dedicated meditation deck facing east \u2014 the sun rises over the Nanda Devi range every morning. It is worth waking up for.',
    ],
  },
  { slug: 'what-nris-need-to-know-before-buying-property-in-uttarakhand', title: 'What NRIs Need to Know Before Buying Property in Uttarakhand', excerpt: 'A step\u2011by\u2011step guide covering FEMA, RERA and repatriation.', image: `${BASE}/assets/23_04_25/hill%20stations/Bhimtal.jpg`, date: 'May 05, 2025', read: '11 min', author: 'Anjali Bisht', tag: 'NRI',
    body: [
      'NRIs and PIOs can freely buy residential and commercial property in India under FEMA \u2014 including in Uttarakhand \u2014 except for agricultural land, plantation property and farmhouses (with narrow exceptions).',
      'Payments must come through normal banking channels \u2014 your NRE, NRO or FCNR account. Cash transactions are not permitted for any amount.',
      'Registration can be done through a Power of Attorney (POA) if you cannot be physically present. Get the POA apostilled or attested at the Indian consulate wherever you live.',
      'Repatriation is capped at USD 1 million per financial year and is available once TDS, capital gains tax and 15CA/CB certifications are in place. Plan for a two-month timeline after sale.',
      'Our NRI desk handles all of the above end-to-end \u2014 from title checks to remote registration to eventual repatriation. Reach out any time; we host virtual site visits over Zoom.',
    ],
  },
];

// export const services = [
//   { title: 'Builder & Developer', desc: 'We offer the best builder and developer services because we value your dreams.' },
//   { title: 'Construction Services', desc: 'We offer high-quality construction services. We make no compromises on quality.' },
//   { title: 'Real Estate Consultant', desc: 'Best real estate advisor to assist you to make the most important decision of your life.' },
//   { title: 'Property Legal Services', desc: 'We provide authentic property legal services from property verification to registration.' },
//   { title: 'Home Loan Services', desc: 'We focus on providing quick and easy home loan services with the best deals.' },
//   { title: 'Vastu Consultant', desc: 'Consult with the best Vastu experts and bring happiness and prosperity into your life.' },
//   { title: 'Interior Designer', desc: 'Top interior designers who will make your home the most comfortable place to live.' },
// ];

export const gallery = [
  `${BASE}/assets/23_04_25/hill%20stations/almora.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/nainital.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/mukteshwar.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/kausani.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/Bhimtal.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/Bhowali_City.jpg`,
  `${BASE}/assets/23_04_25/hill%20stations/naukuchiatal.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/chaubatia%20garden.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/rani%20jheel.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/Golf-Course.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/haidakhan-temple.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/katarmal%20suntemple.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/nanda_devi.jpg`,
  `${BASE}/assets/23_04_25/nearby%20places/Mankameshwar-Temple.webp`,
  `${BASE}/assets/23_04_25/nearby%20places/Kumaon-Regimental-Centre-Museum.jpg`,
  `${BASE}/assets/23_04_25/Usp/smart%20lifestyle.jpg`,
  `${BASE}/assets/23_04_25/Usp/sustainability.jpg`,
  `${BASE}/assets/23_04_25/Usp/yoga-girl.jpg`,
  `${BASE}/assets/23_04_25/Usp/children%20playing.jpeg`,
  `${BASE}/assets/23_04_25/Usp/nature%20-%20himalyan%20view.jpg`,
];

export const faqs = [
  { q: 'What is included in the plot price?', a: 'The plot price includes freehold land registered in your name, internal road access, boundary demarcation, and basic utility connections to the plot line.' },
  { q: 'Is the project RERA approved?', a: 'Yes. Our flagship project The Ewen Park is registered under UKREA05230000398.' },
  { q: 'Can NRIs buy property with Ewen Realtors?', a: 'Absolutely. We have a dedicated NRI desk that handles documentation, payments and remote registration.' },
  { q: 'What is the payment plan?', a: '40% at booking followed by four milestone installments of 15% each. Full details on our Home page.' },
  { q: 'Is there any discount for defence families?', a: 'Yes. We offer a flat 5% discount to families of Indian soldiers in memory of Late Nayak Kesar Singh Rawat.' },
  { q: 'Do you help with construction?', a: 'Yes. We have empanelled architects and contractors who can design and build your villa on the plot you buy.' },
];

export const investors = [
  { title: 'Financial Highlights', text: 'Consistent 22% YoY revenue growth over the last 3 years with zero debt on the balance sheet.' },
  { title: 'Land Bank', text: '86+ acres of clear-title land banked across Ranikhet, Almora and Kausani districts.' },
  { title: 'Project Pipeline', text: '3 signature townships live and 2 in advanced pre-launch through 2026.' },
  { title: 'ESG Commitment', text: 'Every township plants 200+ native trees per acre and uses locally sourced Kumaoni stone.' },
];

export const careers = [
  { role: 'Sales Manager \u2014 NCR', type: 'Full time', location: 'Delhi / Gurugram', desc: '4+ years in real estate sales, comfortable travelling to Uttarakhand for site visits.' },
  { role: 'Site Engineer', type: 'Full time', location: 'Ranikhet', desc: 'B.E. Civil with 3+ years managing hill construction sites.' },
  { role: 'Digital Marketing Lead', type: 'Full time', location: 'Kathgodam / Remote', desc: 'Owns paid, SEO and content across our funnel end\u2011to\u2011end.' },
  { role: 'Customer Success Executive', type: 'Full time', location: 'Kathgodam', desc: 'Warm, patient and process\u2011driven. Loves talking to home buyers.' },
];

export const company = {
  name: 'Ewen Realtors',
  tagline: 'Defining Dreams in the Mountains',
  rera: 'UKREA05230000398',
  phone: '+91 852-616-4444',
  whatsapp: '+918126717243',
  phoneRaw: '+91 852-616-4444',
  email: 'info@ewenrealtors.com',
  address: 'Near Udupiwala, NH 109, Nainital Road, Kathgodam, Uttarakhand \u2013 263126, India',
  youtube: 'https://www.youtube.com/embed/ydZEb-jL49c',
};

export const services = [
  {
    slug: 'builder-and-developer',
    title: 'Builder & Developer',
    tagline: 'We value your dreams \u2014 and we build like we mean it.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Builder%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Builder-Developer.jpg',
    lead: 'Since 2011, Ewen Realtors has designed and delivered residential and commercial projects across Uttarakhand \u2014 blending traditional Kumaoni craft with modern engineering.',
    intro: [
      'We work at the intersection of thoughtful design and clean execution. Every project we take on starts with a simple question: what will make this home a joy to live in ten years from now?',
      'That question shapes everything \u2014 the material we source, the local artisans we hire, the finishes we choose. The result is a portfolio of homes, apartments, villas and townships that hold their value and their character.',
    ],
    sections: [
      {
        heading: 'Projects we take on',
        text: 'From a single hillside home to a fully gated township, we bring the same rigor to every scale.',
        bullets: ['Independent houses', 'Apartments & row homes', 'Villas & cottages', 'Home renovations', 'Commercial complexes', 'Boutique hotels & resorts'],
      },
      {
        heading: 'What we deliver end-to-end',
        text: 'A single accountable team from ground-breaking to hand-over.',
        bullets: ['Civil & structural engineering', 'Construction & project management', 'Structural reinforcement & retrofits', 'Mechanical & electrical engineering', 'Modular building systems', 'Interior fit-out & handover'],
      },
      {
        heading: 'Our obligations to you',
        text: 'A developer\u2019s job is not just to build. It is to build a relationship that outlives the project.',
        bullets: [
          'Clear title, RERA registration and municipal approvals before a single brick is laid',
          'Transparent explanation of carpet vs. built-up vs. super area',
          'Fixed timelines and honest updates when reality demands change',
          'Quality materials sourced within your budget',
          'No hidden charges \u2014 taxes, sewerage and connections are disclosed upfront',
        ],
      },
    ],
    faqs: [
      { q: 'What is your usual timeline for a villa build?', a: '10 to 14 months from plot handover to key handover, depending on plot size, weather windows and design complexity.' },
      { q: 'Do you take on renovations of older hill homes?', a: 'Yes. We do heritage-sensitive renovations of old Kumaoni homes across Uttarakhand, with structural retrofits where needed.' },
      { q: 'Do you build commercial projects too?', a: 'Yes. Boutique hotels, mixed-use commercial blocks and office spaces are part of our regular pipeline.' },
    ],
  },
  {
    slug: 'construction-service',
    title: 'Construction Services',
    tagline: 'Built to last a hundred winters.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Construction%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Construction-Services.jpg',
    lead: 'A home is built once. That is why our construction team obsesses about every detail \u2014 from soil testing to seismic reinforcement to the finish of the last skirting board.',
    intro: [
      'We have been delivering construction services in Uttarakhand since 2011. Our project managers, engineers and site supervisors bring decades of combined experience to every build.',
      'Our reputation rests on three things: knowledge, trust and transparency. You will always know what is happening on your site, why it is happening and what it will cost.',
    ],
    sections: [
      {
        heading: 'What we cover',
        text: 'End-to-end construction management from a single accountable team.',
        bullets: ['Project management & scheduling', 'Cost estimation & value engineering', 'Soil investigation & foundation design', 'Structural design & construction', 'Interior fit-outs & MEP', 'Post-completion maintenance'],
      },
      {
        heading: 'Why owners keep choosing us',
        text: 'Five reasons buyers and self-build clients recommend us across the state.',
        bullets: [
          'Decades of experience with hill construction and its quirks',
          'A dedicated soil and geo-technical team \u2014 no shortcuts on foundations',
          'Strict cost control at every construction milestone',
          'Earthquake-resistant designs as a baseline, not a premium',
          'Renovation and heritage restoration specialists',
        ],
      },
      {
        heading: 'Benefits of managed construction',
        text: 'Why hiring us beats a local contractor \u2014 by the numbers.',
        bullets: [
          'Materials procured directly from source at institutional rates',
          'Milestone-based reporting with weekly photos and site videos',
          'Fixed timelines backed by penalty clauses',
          'Safety-first sites with insured labour and daily supervision',
        ],
      },
    ],
    faqs: [
      { q: 'What is the main purpose of your construction service?', a: 'To deliver a well-built, safe and beautiful home on schedule and within budget \u2014 without asking the owner to babysit the site every day.' },
      { q: 'Why work with Ewen Realtors for construction?', a: 'Because we combine a deep local network of masons, carpenters and suppliers with a professional project-management layer you would only expect from a large city firm.' },
      { q: 'What do managed construction services really include?', a: 'Quality materials at institutional rates, on-schedule milestones, safety protocols, and a single number to call for anything site-related.' },
    ],
  },
  {
    slug: 'real-estate-consultant',
    title: 'Real Estate Consultant',
    tagline: 'A trusted advisor for one of your biggest decisions.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Real%20Estate%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Real-Estate-Consultant.jpg',
    lead: 'Buying a home is a life-changing decision. Our real-estate advisors help you make it with a clear head and a full understanding of what you are stepping into.',
    intro: [
      'We have walked hundreds of families through the process \u2014 first-time buyers, investors, NRIs, retirees. Every conversation starts with your goal, not our inventory.',
      'When our property is right for you, we will show it to you. When it is not, we will tell you honestly and point you in a better direction.',
    ],
    sections: [
      {
        heading: 'How we consult',
        text: 'A structured, no-pressure process built on listening.',
        bullets: ['Discovery call to understand your goals and budget', 'Curated shortlist across our own inventory and partner projects', 'Site visits with a real advisor \u2014 not a commission-only agent', 'Legal, financial and tax view of every option', 'Negotiation support and post-purchase help'],
      },
      {
        heading: 'Who we work with',
        text: 'Every kind of buyer, with a customized approach for each.',
        bullets: ['First-time home buyers', 'NRIs and PIOs buying in India', 'Retirees looking for a peaceful second home', 'Investors optimising for yield and appreciation', 'Corporates buying land for guest houses and retreats'],
      },
    ],
    faqs: [
      { q: 'Do you charge for a consultation?', a: 'The first consultation is on us. If you decide to work with us on a purchase, our fee structure is completely transparent and shared upfront.' },
      { q: 'Do you only sell your own projects?', a: 'No. We have a curated network of vetted partner developers across Uttarakhand and will happily point you to them when they are the better fit.' },
    ],
  },
  {
    slug: 'property-legal-services',
    title: 'Property Legal Services',
    tagline: 'Airtight paperwork so you can sleep easy.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Property%20Legal%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Property-Legal-Services.jpg',
    lead: 'From title search to final registration, our in-house legal team makes sure every document in your file is watertight.',
    intro: [
      'Land disputes in the hills are usually paperwork disputes at heart. We have made it our mission to eliminate them for our buyers.',
      'Every property we sell goes through a 30-year chain-of-title check, RERA verification and municipal-approval audit before it is even listed.',
    ],
    sections: [
      {
        heading: 'What we handle',
        text: 'A full-stack legal service so nothing is missed.',
        bullets: ['Chain-of-title verification (30+ years)', 'Encumbrance certificate search', 'RERA & municipal approval audit', 'Sale-deed drafting and vetting', 'Stamp duty & registration support', 'Mutation and property-tax registration'],
      },
      {
        heading: 'For NRIs and remote buyers',
        text: 'Buy with confidence from anywhere in the world.',
        bullets: ['Apostilled Power of Attorney drafting', 'Consulate-attested document handling', 'Remote e-signing where permitted', 'End-to-end registration on your behalf'],
      },
    ],
    faqs: [
      { q: 'Do you check titles for properties I am buying from other sellers?', a: 'Yes. Our legal team offers standalone title verification and due diligence for any Uttarakhand property, not just ours.' },
      { q: 'How long does the legal process usually take?', a: 'A standard title check plus registration takes 3 to 5 weeks. NRI cases with POA typically add another 2 weeks.' },
    ],
  },
  {
    slug: 'home-loan-services',
    title: 'Home Loan Services',
    tagline: 'The right loan at the right rate \u2014 with none of the paperwork pain.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Home%20Loan%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Home-Loan-Services.jpg',
    lead: 'We have relationships with all the major banks and NBFCs, and we will get you a rate a full-time buyer walking in off the street simply cannot match.',
    intro: [
      'Home loans have a hundred moving parts \u2014 eligibility, LTV, tenure, insurance, tax benefit. We simplify all of it into a one-page comparison you can act on in ten minutes.',
      'Our loans desk has moved more than \u20b9500 crore of home finance for our buyers. That volume translates to real leverage on your behalf.',
    ],
    sections: [
      {
        heading: 'What we do for you',
        text: 'A concierge home-loan service, entirely free for our buyers.',
        bullets: ['Eligibility check across 12+ lenders', 'Rate & tenure negotiation on your behalf', 'Document collation and submission', 'Sanction letter tracking', 'Disbursement coordination with builder', 'Tax-benefit and 80C planning'],
      },
      {
        heading: 'Loan products we handle',
        text: 'Every kind of buyer, every kind of loan.',
        bullets: ['Home purchase loans', 'Plot + construction loans', 'Balance transfer & top-up', 'NRI home loans', 'Loan against property'],
      },
    ],
    faqs: [
      { q: 'Do you charge a fee?', a: 'Not from you. We are compensated by our lender partners on successful disbursement.' },
      { q: 'Can NRIs get home loans through you?', a: 'Yes. We work with lenders who specialize in NRI and PIO home loans, including for buyers in the US, UK, UAE and Singapore.' },
    ],
  },
  {
    slug: 'vastu-consultant',
    title: 'Vastu Consultant',
    tagline: 'Design your home in harmony with the elements.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Vastu%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Vastu-Consultant.jpg',
    lead: 'Our on-panel Vastu consultants have advised hundreds of families across Uttarakhand \u2014 helping them design homes that feel as good as they look.',
    intro: [
      'Vastu is not superstition. It is a design tradition rooted in orientation, light and air-flow \u2014 principles modern architects rediscover under different names.',
      'Whether you want a formal Vastu-compliant home or just a house that feels naturally balanced, our consultants will make it work with your plot and your taste.',
    ],
    sections: [
      {
        heading: 'How we work with you',
        text: 'A calm, practical process \u2014 not a lecture.',
        bullets: ['Plot analysis for orientation and slope', 'Entrance, kitchen and bedroom positioning', 'Puja room and stair placement', 'Correction plans for existing homes', 'On-site visits and video consultations'],
      },
      {
        heading: 'When Vastu is worth doing',
        text: 'A few moments where a small change makes a big difference.',
        bullets: ['Before finalising a floor plan for a new build', 'When a room "feels off" in an existing home', 'Before major renovations or extensions', 'When buying a resale home with poor orientation'],
      },
    ],
    faqs: [
      { q: 'Do I have to follow every Vastu rule?', a: 'No. Our consultants share what matters most for your plot and lifestyle, and leave the rest to you. Vastu should serve you, not the other way around.' },
      { q: 'Can Vastu be corrected in an already-built home?', a: 'Often yes. Many corrections are cosmetic \u2014 orientation of furniture, mirror placement, colour palette \u2014 not structural.' },
    ],
  },
  {
    slug: 'interior-designer',
    title: 'Interior Designer',
    tagline: 'Interiors that feel like home from day one.',
    icon: 'https://ewenrealtors.com/assets/images/services/icons/Interior%20Icon.svg',
    hero: 'https://ewenrealtors.com/assets/images/services/Interior-Designer.jpg',
    lead: 'Our in-house design studio brings your home to life \u2014 with a warm, mountain-appropriate aesthetic that ages beautifully.',
    intro: [
      'A great interior in the hills is not the same as a great interior in a metro flat. Light behaves differently, humidity is real, and the outdoors is always trying to come in \u2014 which is exactly what you want.',
      'Our designers have shaped over 200 homes across Uttarakhand and know exactly how to make a house feel warm, unfussy and effortlessly beautiful.',
    ],
    sections: [
      {
        heading: 'What we design',
        text: 'Whole homes or single rooms \u2014 done in-house or supervised remotely.',
        bullets: ['Full-home turnkey interiors', 'Single room makeovers', 'Modular kitchens & wardrobes', 'Custom carpentry in local wood', 'Lighting & finishes', 'Soft furnishing & styling'],
      },
      {
        heading: 'Our design philosophy',
        text: 'The mountains inform every choice we make.',
        bullets: [
          'Local Kumaoni stone and pine wherever we can',
          'Layered lighting for long winter evenings',
          'Storage designed for actual mountain living \u2014 boots, jackets, gear',
          'Neutral palettes that let the view be the hero',
          'Finishes that ignore humidity and monsoon',
        ],
      },
    ],
    faqs: [
      { q: 'Can you design for a home not built by Ewen Realtors?', a: 'Absolutely. Around 40% of our interior projects are for homes built by other developers or by the owner themselves.' },
      { q: 'What is the typical cost?', a: 'Our full-home turnkey interiors start around \u20b91,800 per sqft and go up based on finishes. We share a fixed quote after a discovery call.' },
    ],
  },
];